export type Pos = {
  id: string;
  name: string;
  fullAddress: string;
  merchantId: string;
  merchantName: string;
  companyId: string;
  type: 'ONLINE' | 'OFFLINE';
  allowsUsedItems: boolean;
};

export function isOnlinePos(pos: Pos) {
  return pos.type === 'ONLINE';
}
